import { useEffect, useState, useRef } from "react";
import LcFetch from "../../lib/shared/fetch";

function fetchSetupIntentSecret(path, subscriptionType) {
  const fetchPath = path || "/setup_intents";
  const [setupIntentData, setSetupIntentData] = useState([]);
  useEffect(() => {
    const fetchClientSecret = async () => {
      const response = await LcFetch(fetchPath, {
        body: JSON.stringify({ subscription: subscriptionType }),
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        method: "POST"
      });
      const json = await response.json();
      setSetupIntentData([json.client_secret, json.setup_intent_id]);
    };
    fetchClientSecret();
  }, []);

  return setupIntentData;
}

async function updateSetupIntent(setupIntentId, subscriptionType) {
  if (!setupIntentId) return;

  try {
    await LcFetch(`/setup_intents/${setupIntentId}`, {
      body: JSON.stringify({ subscription: subscriptionType }),
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "PUT"
    });
  } catch (error) {
    console.error("Failed to update setup intent:", error);
  }
}

function fetchUpgradePrice(upgradePrice, upgradePricePath) {
  const [fetchedUpgradePrice, setUpgradePrice] = useState(upgradePrice);
  const pollingRef = useRef(null);
  useEffect(() => {
    const pricePolling = () => {
      pollingRef.current = setInterval(async () => {
        const response = await LcFetch(upgradePricePath);
        const data = await response.json();
        if (response.ok) {
          setUpgradePrice(data.upgrade_price);
        } else {
          setUpgradePrice({ errorMessage: data.errorMessage });
        }
        if (data?.upgrade_price?.price || !response.ok) {
          clearInterval(pollingRef.current);
        }
      }, 1000);
    };

    if (!fetchedUpgradePrice.price && !fetchedUpgradePrice.errorMessage) {
      pricePolling();
    }

    return () => {
      clearInterval(pollingRef.current);
    };
  }, []);
  return fetchedUpgradePrice;
}

export { updateSetupIntent, fetchSetupIntentSecret, fetchUpgradePrice };
